// extracted by mini-css-extract-plugin
module.exports = {"root":"loader-module__root___10v5h","loader":"loader-module__loader___3NkKU","lds-rolling":"loader-module__lds-rolling___2BeRf","message":"loader-module__message___2zyFD"};